import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeGammaCapital';
const args = {};

export class ModeGammaCapital extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
